<template>
	<div>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Penyesuaian Stok</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link class="text-deco" :to="{ name: 'add-stock-adjustment' }" v-if="hasAccess('add-stock-adjustment')">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Buat Penyesuaian</div>
							</v-btn>
						</router-link>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Kode Penyesuaian Stok" v-model="adjustment_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="4">
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalAdjustment)" label="Tanggal Penyesuaian" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalAdjustment"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="2"></v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<div>
				<v-card outlined v-if="listAdjustment.length == 0 && adjustmentPagination">
					<div class="py-3">
						<not-found></not-found>
					</div>
				</v-card>
				<v-card class="mb-3" outlined v-for="adjustment in listAdjustment" :key="adjustment.product_stock_adjustment_code">
					<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Penyesuaian {{ adjustment.product_stock_adjustment_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn small text depressed class="primary" @click="printSA(userData.user_warehouse_id, adjustment.product_stock_adjustment_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Tanggal Penyesuaian</div>
									<div class="subtitle-2">{{ adjustment.product_stock_adjustment_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3 class="pl-4">
									<div class="body-2 oppacity-75">Pengguna</div>
									<div class="subtitle-2 text-capitalize">{{ adjustment.product_stock_adjustment_user_name }}</div>
								</v-flex>
								<v-flex xs12 sm6 md6 class="pl-4">
									<div class="body-2 oppacity-75">Catatan</div>
									<div class="subtitle-2">{{ adjustment.product_stock_adjustment_note }}</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
					<div class="pt-3">
						<v-card tile elevation="0">
							<v-data-table :headers="headersProduct" :items="adjustment.product_stock_adjustment_detail" :items-per-page="1000" class="elevation-0" hide-default-footer>
								<template v-slot:item.product_stock_adjustment_detail_type="{ item }">
									<div v-if="item.product_stock_adjustment_detail_type == 'in'">Masuk</div>
									<div v-else>Keluar</div>
								</template>
								<template v-slot:item.product_stock_adjustment_detail_quantity="{ item }">
									<div>{{ item.product_stock_adjustment_detail_quantity | toNumber }}</div>
								</template>
							</v-data-table>
						</v-card>
					</div>
				</v-card>
			</div>
			<div class="pt-5">
				<v-row v-if="adjustmentPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="adjustmentPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import modalPrint from '@/views/MLwarehouse/stockAdjustment/PrintSA'
import { mapActions,  mapState } from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalPrint
	},
	data() {
		return {
			menu: false,
			tanggalAdjustment: [],
			loading: true,
			headersProduct: [
			{ text: 'Nama Produk', value: 'product_stock_adjustment_detail_product_name', sortable: false, width: '50%' },
			{ text: 'Tipe', value: 'product_stock_adjustment_detail_type' },
			{ text: 'Jumlah', value: 'product_stock_adjustment_detail_quantity', align: 'center'},
			],
			adjustment_code: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'product_stock_adjustment_code'
			},
			adjustment_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'product_stock_adjustment_datetime'
			},
			sortBy: 'product_stock_adjustment_id',
			sortDir: 'DESC',
			page: 1,
			limit: 10,
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			dialog: false,
			dialogPrint: false,
			dialogConfirm: false,
			params:[],
			procces_po_id: '',
			poProccess : '',
		}
	},
	computed: {
		...mapState('stockAdjustment', ['listAdjustment', 'detailSA', 'adjustmentPagination']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('stockAdjustment', ['getAdjustment', 'getDetailSA', 'exportAdjustment']),
		...mapActions('common', ['getLetterHeader']),

		exportData(){
			this.exportAdjustment(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		getData() {
			this.getAdjustment(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
				this.loading = false
			})
		},
		resetFilter(){
			this.adjustment_code.value = ''
			this.adjustment_date.value = ''
			this.tanggalAdjustment = []
			this.page = 1
			this.getData()
		},
		cari(){
			this.params = []
			if (this.adjustment_code.value)
				this.params.push(this.adjustment_code)
			if (this.adjustment_date.value){
				if (this.adjustment_date.value.length > 1) {
					this.adjustment_date.value.sort()
					let date = this.adjustment_date.value.join('::')
					this.adjustment_date.value = date
				}
				this.params.push(Object.assign({}, this.adjustment_date))
			}
			this.page = 1
			this.getData()
		},
		changePage(page){
			this.page = page
			this.getData()
			this.getDetailSA()
		},
		async printSA(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailSA(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Penyesuaian Stok`)
		this.getData()
	},
	watch: {
		tanggalAdjustment(val) {
			this.adjustment_date.value = val
		},
		limit() {
			this.page = 1
			this.getData()
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>